// Errors
import { ArgumentNullError } from "@ms/uno-errors/lib/local/errors/ArgumentNullError";
import { MultipleDaysOrDatesRecurrenceCalculator } from "./MultipleDaysOrDatesRecurrenceCalculator";
// Utilities
import { Temporal } from "temporal-polyfill-lite";
/**
 * Represents a yearly recurrence pattern calculator.
 * @example 14th of February every year. (YearlyFixed)
 * @example Fourth Thursday of November every year. (YearlyFloating)
 */ export class YearlyRecurrenceCalculator extends MultipleDaysOrDatesRecurrenceCalculator {
    isSameOrBefore(start, end) {
        // Set to beginning of the year then check. This is because we iterate through the year
        return Temporal.PlainDate.compare(start.with({
            month: 1,
            day: 1
        }), end.with({
            month: 1,
            day: 1
        })) <= 0;
    }
    getDurationBetweenDateAndPatternStartDate(date) {
        // Set to beginning of month on the month for the yearly pattern and return number of whole years between the given date and the pattern start date.
        return date.with({
            day: 1,
            month: this.month
        }).since(this.patternStartDate.with({
            day: 1,
            month: this.month
        }), {
            smallestUnit: "years"
        }).years;
    }
    constructor(schedule, patternStartDateAsInstant, occurrenceIndex){
        super(schedule, patternStartDateAsInstant, occurrenceIndex, {
            years: 1
        });
        if (schedule.pattern.month == null) {
            throw new ArgumentNullError("month");
        }
        this.month = schedule.pattern.month;
    }
}
